export default __webpack_public_path__ + "static/image3-7488f0723ead06e9ad0d19a9a16b598b.jpg";